import * as React from 'react';
import Box from '@mui/material/Box';
import { APP_HEADER_HEIGHT } from './layouts/appHeader';

type MainContentProp = {
  open: boolean;
  shrinkWidth: number;
  children: React.ReactNode;
};

export const MainContent = ({open, shrinkWidth, children}:MainContentProp) => {

    return (
        <Box
        component="main"
        sx={(theme) => ({
            flexGrow: 1,
            p: 3,
            mt: `${APP_HEADER_HEIGHT}px`,
            marginLeft: open ? 0 : `-${shrinkWidth}px`,
            transition: theme.transitions.create('margin', {
            easing: open
                ? theme.transitions.easing.easeOut
                : theme.transitions.easing.sharp,
            duration: open
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
        })}
        >
            {children}
        </Box>
    );
}